module.exports = __webpack_public_path__ + "static/media/plans-bg-logo-blue.2b5aeefd.svg";